import getSelectedTableView from '../utils/getSelectedTableView';
import getListViewStore from '../store/Store';
import { owaComputedFn } from 'owa-computed-fn';

const getComputedSelectedRowKeysSize: () => number = owaComputedFn(
    function getComputedSelectedRowKeysSize(): number {
        return getSelectedTableView()?.selectedRowKeys.size ?? 0;
    }
);
export default getComputedSelectedRowKeysSize;

export const getComputedSelectedRowKeysSizeForTable: (tableViewId: string) => number =
    owaComputedFn(function getComputedSelectedRowKeysSizeForTable(tableViewId: string): number {
        return getListViewStore().tableViews.get(tableViewId)?.selectedRowKeys.size ?? 0;
    });
